module.exports = (__webpack_require__(3))(175);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/FolderCollection.js from dll-reference girder_lib
// module id = 50
// module chunks = 0